import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Trans } from '@lingui/react';
import { throughputUnitLabelFromThroughputControlType } from 'hooks/useDisplayUnits/display';
import { BasicDisplayUnits, unitLabels } from 'hooks/useDisplayUnits/useDisplayUnits';
import {
  BackfillRecipeDto,
  ThroughputControlType,
  UnitSystem,
  CustomUnitFields
} from 'providers/api';
import { round } from 'utils/number';
import UnitSystemDetail, { UnitSystemValue } from './UnitSystemDetail';

interface RecipeHydraulicFillDetailsProps {
  recipe: BackfillRecipeDto;
  unitSystemPreference: UnitSystem;
  throughputControlType: ThroughputControlType;
  customUnitFields: CustomUnitFields[];
}

const RecipeHydraulicFillDetails = ({ recipe, unitSystemPreference, throughputControlType, customUnitFields }: RecipeHydraulicFillDetailsProps) => (

  <>
    <UnitSystemDetail
      designed={recipe.hydraulicSpecification?.throughput}
      selected={recipe.hydraulicSpecification?.throughput}
      unitSystem={unitSystemPreference}
      unitInfo={throughputUnitLabelFromThroughputControlType(throughputControlType)}
      decimalPlaces={2}
      customUnitFields={customUnitFields}
    />

    <TableRow>
      <TableCell component="th" scope="row"><Trans id="Binder:Tailings">Binder:Tailings</Trans></TableCell>
      <TableCell align="right" width="auto">{`1:${round(100 / ((recipe.hydraulicSpecification?.binderTailingsRatio ?? 0) * 100), 0)}`}</TableCell>
      <TableCell align="right">{`1:${round(100 / ((recipe.hydraulicSpecification?.binderTailingsRatio ?? 0) * 100), 0)}`}</TableCell>
    </TableRow>
    <TableRow>
      <TableCell component="th" scope="row"><Trans id="Concentration">Concentration</Trans></TableCell>
      <TableCell align="right" width="auto">{`${round(recipe.hydraulicOptimisedSpecification?.massConcentration ?? 0, 2)} %m`}</TableCell>
      <TableCell align="right">{`${round(recipe.hydraulicSelectedSpecification?.massConcentration ?? 0, 2)} %m`}</TableCell>
    </TableRow>

    <TableRow>
      <TableCell component="th" scope="row"><Trans id="Settling Velocity">Settling Velocity</Trans></TableCell>
      <TableCell align="right" width="auto">{ }</TableCell>
      <TableCell align="right">
        <UnitSystemValue
          value={recipe.hydraulicSelectedSpecification?.settlingVelocity}
          unitSystem={unitSystemPreference}
          unitInfo={unitLabels[BasicDisplayUnits.Speed]}
          decimalPlaces={2}
          customUnitFields={customUnitFields}
        />
      </TableCell>
    </TableRow>

    <TableRow>
      <TableCell component="th" scope="row"><Trans id="Minimum Velocity">Minimum Velocity</Trans></TableCell>
      <TableCell align="right" width="auto">{ }</TableCell>
      <TableCell align="right">
        <UnitSystemValue
          value={recipe.hydraulicSelectedSpecification?.minVelocity}
          unitSystem={unitSystemPreference}
          unitInfo={unitLabels[BasicDisplayUnits.Speed]}
          decimalPlaces={2}
          customUnitFields={customUnitFields}
        />
      </TableCell>
    </TableRow>
  </>
);

export default RecipeHydraulicFillDetails;
